import { FilterType } from "@/shared/enums/Filter.enum";
import { Column, FilterConfig, PanelTab } from "@/shared/types";

const filters: FilterConfig[] = [
	{
		id: "productName",
		name: "Product Name",
		description: "Filter by Product Name",
		items: [],
		type: FilterType.INPUT,
	},
];

const panels: PanelTab[] = [
	{
		title: "All",
	},
	{
		title: "Archived",
	},
];

const availableColumns: Column[] = [
	{ field: "productName", label: "Product name" },
	{ field: "productType", label: "Product Type" },
	{ field: "pricing", label: "Pricing" },
	{ field: "totalUsers", label: "Total users" },
	{ field: "newUsers", label: "New users" },
	{ field: "dhcsApplied", label: "DHCs applied" },
];

const productColumns: string[] = ["productName", "productType", "deliveryType", "pricing", "totalUsers", "dhcsApplied"];

export { filters, panels, availableColumns, productColumns };
